import React, { useState ,useRef} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIDatePicker from "components/datepicker";
import codeDataStore from "common/codedata/store/CodeDataStore";
import CommonUtil from 'utils/CommonUtil';
import DateUtil from 'utils/DateUtil';
import UISelect from "components/selectbox/UISelect";
import commonPopupStore from "../../../../common/popup/store/CommonPopupStore";
import UI from "components/UI";
import UIUtils from "utils/UIUtils";
import StringUtil from 'utils/StringUtil';
import DateUtils from 'utils/DateUtil';
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";


function ContentsContainer() {
	const modaladm3110 = useToggleState({});	
	const modaladm3120 = useToggleState({});	

	const initStartDate = new Date().getFullYear();
	const initEndDate = new Date().getFullYear()+5;
	
	const [yyyy,setYyyy] = useState(String(new Date().getFullYear()));
	const [searchYyyy,setSearchYyyy] = useState(String(new Date().getFullYear()));

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(1); //기본 row count
	const [dateNum,setDateNum] = useState(2); //날짜 기본값
	const [loadFinish,setLoadFinish] = useState(false);

	/** 검색조건 */
	const [startDate,setStartDate] = useState(new Date(new Date().getFullYear()+'-01-01'));
	const [endDate,setEndDate] = useState(new Date(new Date().getFullYear()+'-12-31'));
	const [bizCd,setBizCd] = useState('');
	const [donNo,setDonNo] = useState('');
	const [corpNm,setCorpNm] = useState('');
	const [receNo,setReceNo] = useState('');
	const [receSts,setReceSts] = useState('');
	const [deptNm,setDeptNm] = useState('');
	const [bizNo,setBizNo] = useState('');
	const [donContDivCd,setDonContDivCd] = useState('');
	const [fileId,setFileId] = useState('');
	
	const [fileInfoUploadList, setFileInfoUploadList] = React.useState<any[]>([]);  //파일업로드 리스트
	const [modaladm3100Open, setModaladm3100Open] = useState(false); //연장공문업로드  팝업오픈여부
	const [modaladm3100ViewOpen, setModaladm3100ViewOpen] = useState(false); //연장공문열람  팝업오픈여부
	
	//초기 데이터 설정
	let totalCnt:number = 0;
	let defaultRowCnt = 20;

	const [modalDonAmtOpen, setModalDonAmtOpen] = useState(false); //출연받은재산사용명세서 팝업오픈여부
	const [modalSuppMoneyOpen, setModalSuppMoneyOpen] = useState(false); //기부금지출명세서 팝업오픈여부
	const [modalPayRedeOpen, setModalPayRedeOpen] = useState(false); //출연금사용명세 팝업오픈여부	

	const [donAmtSheetRowCnt,setDonAmtSheetRowCnt] = useState(0);
	const [suppMoneySheetRowCnt,setSuppMoneySheetRowCnt] = useState(0);
	const [payRedeSheetRowCnt,setPayRedeSheetRowCnt] = useState(0);

	const [yearList, setYearList] = React.useState<any[]>([{value : new Date().getFullYear()+'', nm : new Date().getFullYear()+'년'}]);
	const [year, setYear] = useState('');
	let defaultYear:number = 2024; //2024년부터 조회 가능
    let start:number = new Date().getFullYear();
	let chkYear:number = 0;
	if(start > defaultYear){
		chkYear = start - defaultYear;
		start = start - chkYear;
	}

	let end = start + chkYear;
	let newYearList = [];
	for(let i = start; i <= end; i++){
		// @ts-ignore
		newYearList.push({value : i+'', nm : i+'년'})
	}

	// 폼체크 여부 
	const [formCheck,setFormCheck] = useState(false);  

	//파일정보 선언 
	//let [fileValue] = useState(new TbComFile());
	const [fileValue, setFileValue] = useState(new TbComFile());
	const [fileValueUpdate, setFileValueUpdate] = useState(new TbComFile());
	let titleText = useRef<string>('');

	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init': {
			"Cfg": {
				"SearchMode": 1,
				"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate": "0",
				"Height": "auto"

			},
			Def: {
				Row: {
					 "CanFormula": 1,
				     "AlternateColor": "#CCDDE4"
				}
				
			},
			//틀고정 좌측 컬럼 설정
			"LeftCols": [
				{"Header": "No","Name": "SEQ","Width": "90"}
			],
			"Cols": [
				{"Header": "No","Type": "Int", "Name": "SEQ","Align": "Center","RelWidth": 0.8,"CanEdit": "0"},
				{"Header": "DON_NO","Type": "Text", "Name": "DON_NO","Align": "Center","RelWidth": 0.1,"CanEdit": "0", "Visible":"0"},
				{"Header": "출연일시", "Type": "Date", "Name": "DON_DATE", "RelWidth": 1.5, "Align": "Center", "CanEdit": "0", Format: "yyyy-MM-dd", DataFormat: "yyyy-MM-dd HH:mm:ss"},
				{"Header": "규모", "Type": "Text", "Name": "CORP_SIZE_CD_NM", "RelWidth": 1, "Align": "Center", "CanEdit": "0"},
				{"Header": "출연기업", "Type": "Text", "Name": "CORP_NM", "RelWidth": 2, "Align": "Center", "CanEdit": "0"},
				{"Header": "사업자번호", "Type": "Text", "Name": "BIZ_NO", "RelWidth": 2, "Align": "Center", "CanEdit": "0"},
				{"Header": "기부금영수증번호","Type": "Text","Name": "DON_RECE_NO","RelWidth": 2.5,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "기부내용", "Type": "Text", "Name": "DON_CONT_DIV_NM", "RelWidth": 1, "Align": "Center" ,"CanEdit": "0"},
				{"Header": "출연재산가액","Type": "Int","Name": "DON_REQ_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0"},
				{"Header": {"Value": "직전년도 사용금액" ,"Color": "#FFDFDF"},"Type": "Int","Name": "PRE_QTY","RelWidth": 2,"Align": "Right" ,"CanEdit": "1",},
				{"Header": {"Value": "해당년도 사용금액" ,"Color": "#FFDFDF"},"Type": "Int","Name": "NOW_QTY","RelWidth": 2,"Align": "Right" ,"CanEdit": "1"},
				{"Header": {"Value": "지원금액" ,"Color": "#FFDFDF"},"Type": "Int","Name": "SUPP_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "1"},
				{"Header": "만기일","Type": "Html", "Name": "DUE_DATE_Formula", "RelWidth": 2.5, "Align": "Center", "CanEdit": "0","Formula": dueDateFormula},
				{
					"Header": "연장공문열람", //Enum에 html태그 넣어서 설정
					"Type": "Enum",
					"Name": "EXT_NOTI_VIEW",
					"Width": 50,
					"Enum": "|<image src='/external/ibsheet/img/filedown.png'></image>|<image src='/external/ibsheet/img/fileview.png'></image>",
					"EnumKeys": "|U|V",
					"RelWidth": 1,
					"Align": "Center",
					"CanEdit": "0",
					"Formula": extCheckFormula
				  },	
				  {"Header": {"Value": "메모" ,"Color": "#FFDFDF"},"Type": "Text","Name": "MEMO","RelWidth": 2,"Align": "Center" ,"CanEdit": "1"},
				  	
			]

		},
		//출연받은 재산의 사용명세서 시트 초기화 구문
		'donAmtSheet': {
			"Cfg": {
				"SearchMode": 3,
			//	"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate": "0",
				"Height": "auto",
				"HeaderMerge": 3,
				"FitWidth": true,
				"PrevColumnMerge": 0
			},
			
			"Cols": [
				{"Header": ["재산종류","재산종류"],"Type": "Text", "Name": "GUBN","Align": "Center","RelWidth": 1,"CanEdit": "0"},
				{"Header": ["출연일자","출연일자"], "Type": "Date", "Name": "DON_DATE", "RelWidth": 2, "Align": "Center", "CanEdit": "0", Format: "yyyy-MM-dd", DataFormat: "yyyy-MM-dd HH:mm:ss"},
				{"Header": ["출연자명","출연자명"], "Type": "Text", "Name": "CORP_NM", "RelWidth": 1.5, "Align": "Center", "CanEdit": "0"},
				{"Header": ["내외국인무기명구분","내외국인무기명구분"], "Type": "Text", "Name": "COUNTRY", "RelWidth": 1, "Align": "Center", "CanEdit": "0"},
				{"Header": ["출연자주민번호(사업자번호)","출연자주민번호(사업자번호)"], "Type": "Text", "Name": "BIZ_NO", "RelWidth": 2, "Align": "Center", "CanEdit": "0"},
				{"Header": ["출연재산수량","출연재산수량"],"Type": "Text","Name": "BIZ_NM1","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0"},
				{"Header": ["출연재산가액","출연재산가액"],"Type": "Int","Name": "DON_REQ_AMT","RelWidth": 1.5,"Align": "Right" ,"CanEdit": "0",},
				{"Header": ["사용금액",{"Value": "직전년도" ,"Color": "#FFDFDF"}],"Type": "Int","Name": "PRE_QTY_EDIT","RelWidth": 1.5,"Align": "Right" ,"CanEdit": "1"},
				{"Header": ["사용금액",{"Value": "해당년도" ,"Color": "#FFDFDF"}],"Type": "Int","Name": "NOW_QTY_EDIT","RelWidth": 1.5,"Align": "Right" ,"CanEdit": "1"},
				{"Header": ["기부금영수증번호","기부금영수증번호"],"Type": "Text","Name": "DON_RECE_NO","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": [{"Value": "전용사업" ,"Color": "#FFDFDF"},{"Value": "전용사업" ,"Color": "#FFDFDF"}],"Type": "Text","Name": "BIZ_NM_EDIT","RelWidth": 2,"CanEdit": "1","Align": "Center"},
				{"Header": ["3년만기도래","3년만기도래"],"Type": "Text","Name": "DUE_CHECK","RelWidth": 2,"CanEdit": "0","Align": "Center"},
				{"Header": ["연장공문","연장공문"],"Type": "Text", "Name": "EXT_NOTI_VIEW","RelWidth": 2, "Align": "Center", "CanEdit": "0"},
			]

		},
		//기부금품 지출 명세서 시트 초기화 구문
		'suppMoneySheet': {
			"Cfg": {
				"SearchMode": 3,
				//"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate": "0",
				"Height": "auto",
				"HeaderMerge": 3,
				"FitWidth": true,
				"PrevColumnMerge": 0
			},
			Def: {
				Row: {
					 "CanFormula": 1,
				     "AlternateColor": "#CCDDE4"
				}
				
			},
			"Cols": [
				{"Header": ["(대표)지급처명(성명/단체명)","(대표)지급처명(성명/단체명)"], "Type": "Text", "Name": "SUPP_CORP_NM", "RelWidth": 2, "Align": "Center", "CanEdit": "0"},
				{"Header": ["주민등록번호(사업자등록번호)","주민등록번호(사업자등록번호)"], "Type": "Text", "Name": "SUPP_BIZ_NO", "RelWidth": 1.5, "Align": "Center", "CanEdit": "0"},
				{"Header": ["기금사업명약칭","기금사업명약칭"],"Type": "Text","Name": "BIZ_SHORT_NM","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": ["수혜인원(단체) 수 (명/개)","수혜인원(단체) 수 (명/개)"], "Type": "Int", "Name": "SUPP_CORP_CNT", "RelWidth": 1.5, "Align": "Center" ,"CanEdit": "0"},
				{"Header": ["지출액","현금"],"Type": "Int","Name": "AMT_M","RelWidth": 1.5,"Align": "Right" ,"CanEdit": "0"},
				{"Header": ["지출액","물품"],"Type": "Int","Name": "AMT_C","RelWidth": 1.5,"Align": "Right" ,"CanEdit": "0"},
				{"Header": ["지출액","합계"],"Type":"Int","Name": "AMT","RelWidth": 1.5,"CanEdit": "0"},			
			]

		},
		//출연금 사용명세서 (수혜대상법인명) 시트 초기화 구문
		'payRedeSheet': {
			"Cfg": {
				"SearchMode": 3,
				//"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate": "0",
				"Height": "auto"

			},
			"Cols": [
				{"Header": "수혜대상 법인명", "Type": "Text", "Name": "SUPP_CORP_NM", "RelWidth": 2, "Align": "Center", "CanEdit": "0"},
				{"Header": "사업자등록번호", "Type": "Text", "Name": "SUPP_BIZ_NO", "RelWidth": 2, "Align": "Center", "CanEdit": "0"},
				{"Header": "사용년월일(집행일)", "Type": "Date", "Name": "PAY_COMPL_DATE", "RelWidth": 1.5, "Align": "Center", "CanEdit": "0", Format: "yyyy-MM-dd"},
				{"Header": "사용금액(집행금액)","Type": "Int","Name": "AMT","RelWidth": 2,"CanEdit": "0"},
				{"Header": "지급신청번호","Type": "Text", "Name": "PAY_REQ_NO","RelWidth": 1, "Align": "Center", "CanEdit": "0"},
				{"Header": "사업명","Type": "Text", "Name": "BIZ_NM","RelWidth": 2, "Align": "Center", "CanEdit": "0"},
				{"Header": "출연기업명","Type": "Text", "Name": "CORP_NM","RelWidth": 2, "Align": "Center", "CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				setYearList(newYearList);
				setYear(String(start));
				var sheetNm = evtParam.sheet;
				
				if(sheetNm.id === "sheet"){
					//초기 데이터 로딩
					doSearch('init');
				}else if(sheetNm.id === "donAmtSheet"){
					getDonAmtSheetData();  //출연받은 재산사용명세서
				}
				else if(sheetNm.id === "suppMoneySheet"){
					getSuppMoneySheetData();  //기부금품지출명세서
				}
				else if(sheetNm.id === "payRedeSheet"){
					getPayRedeSheetData();  //기부금품지출명세서
				}

				

			},
			//시트 더블클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				var sheet = evtParam.sheet;
				var row = sheet.getFocusedRow();
				sheet.selectRow( row, 1);
				if(sheet.id === "sheet"){
					var vDON_NO = row["DON_NO"];
					var vEXT_NOTI_FILE_ID = row["EXT_NOTI_FILE_ID"];
					setDonNo(vDON_NO);
					setFileId(vEXT_NOTI_FILE_ID);

					if(evtParam.col == "EXT_NOTI_VIEW" ){
						if(vEXT_NOTI_FILE_ID ==''){
							return;
						}else{
							uploadFileReView(vEXT_NOTI_FILE_ID);
						}

						
						
						let vEXT_NOTI_VIEW = row["EXT_NOTI_VIEW"];
						if(vEXT_NOTI_VIEW == 'U'){      //연장공문파일 업로드
							titleText.current = "연장공문 파일업로드";
							//setModaladm3100Open(true);
						}
						else if(vEXT_NOTI_VIEW == 'V'){  //연장공문파일 미리보기 
							titleText.current = "연장공문 열람";
							//uploadFileReView(vEXT_NOTI_FILE_ID);
						}
						
					}
				}

			},
			onAfterEdit : function(evtParam) {

				var sheet = evtParam.sheet;
				var row = sheet.getFocusedRow();
				sheet.selectRow( row, 1);
				if(sheet.id === "sheet"){
					let preQty:number = row["PRE_QTY"] == undefined?0:row["PRE_QTY"];

					if(evtParam.col == "PRE_QTY" ){
						preQty = sheet.getEditText(); 
						if(preQty == undefined){
							preQty = 0;
						}
					}
				}
			},

			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				let sliceData = [];
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					sliceData = d.slice(0, defaultRowCnt);
					_data = JSON.stringify(sliceData, null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}
			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				//@ts-ignore
				if (currentPage != -1 && currentPage != page) {
					makePageIndex(page);
				}

			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//시트객체 생성
		'createDonAmtSheet':function () {
			let options = this.donAmtSheet;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'donAmtSheet', // 생성할 시트의 id
				el: 'sheetDiv1', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//시트객체 생성
		'createSuppMoneySheet':function () {
			let options = this.suppMoneySheet;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'suppMoneySheet', // 생성할 시트의 id
				el: 'sheetDiv2', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.suppMoneyData // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//시트객체 생성
		'createPayRedeSheet':function () {
			let options = this.payRedeSheet;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'payRedeSheet', // 생성할 시트의 id
				el: 'sheetDiv3', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.payRedeData // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},

		

		//법인세공시 엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			let filename = "법인세공시_"+today+".xlsx";
			//@ts-ignore
			sheet.down2Excel({ fileName: filename, SheetDesign: 1, downCols : makeSkipCol() });

		},
		//출연받은 재산의 사용명세서 엑셀 다운로드
		'exportDonAmtSheetData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			
			var param = {
				fileName:"출연받은재산사용명세서_"+today+".xlsx",
				titleText:"출연받은 재산의 사용명세서||||||||||",
				userMerge:"0,0,1,12 1,0,2,1 1,1,2,1 1,2,2,1 1,3,2,1 1,4,2,1 1,5,2,1 1,6,2,1 1,7,1,2 1,9,2,1 1,10,2,1 1,11,2,1 1,12,2,1"
  		    };
			
			//@ts-ignore
			IBSheet.donAmtSheet.down2Excel(param);
		},
		//기부금품 지출 명세서 엑셀 다운로드
		'exportSuppMoneySheetData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			
			var param = {
				fileName:"기부금품 지출 명세서_"+today+".xlsx",
				titleText:"기부금품 지출 명세서||||||||",
				userMerge:"0,0,1,7 1,0,2,1 1,1,2,1 1,2,2,1 1,3,2,1 1,4,1,3" 
  		    };
			
			//@ts-ignore
			IBSheet.suppMoneySheet.down2Excel(param);
		},

		//출연금 사용명세 엑셀 다운로드
		'exportPayRedeSheetData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			
			var param = {
				fileName:"출연금 사용명세_"+today+".xlsx",
				titleText:"출연금 사용명세||||||||||",
				userMerge:"0,0,1,5 1,0,2,1 1,1,2,1 1,2,2,1 1,3,2,1 1,4,2,1" 
  		    };
			
			//@ts-ignore
			IBSheet.payRedeSheet.down2Excel(param);
		},
		//조회 데이터
		'data':[],
		'suppMoneyData':[],
		'payRedeData':[]
	}

	function makeSkipCol() {
		//visible:0인 컬럼, SEQ, 상태컬럼, check 컬럼을 제외한다.
		//@ts-ignore
		var cols = sheet.getCols();
		var colsArr = new Array();
	  
		for (var i = 0; i < cols.length; i++) {
	     //@ts-ignore
		  var colName = sheet.getAttribute({col: cols[i],attr: "Name"});
		 //@ts-ignore 
		  var colVisible = sheet.getAttribute({col: cols[i],attr: "Visible"});
	  
		  if (colVisible && colName != "EXT_NOTI_VIEW") {
			colsArr.push(colName);
		  }
		}
		//console.log(colsArr.join("|"));
		
		return colsArr.join("|");
	  }

	//출연받은 재산의 사용명세서 
    async function getDonAmtSheetData (){
		let param = {};

		param = {
			"YEAR" : year == ''?new Date().getFullYear():year
		};


		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'adm_3100_getDonAmtSheetData',
			data: param
		})

		//전체데이터
		let result = response.LIST;

		if(result !=null && result.length > 0){
		// 	//전체ROW개수
		// 	totalCnt = Object.keys(result).length;
			setDonAmtSheetRowCnt(Object.keys(result).length);
		}

		//데이터 처리
		ib.data = result;

		// @ts-ignore
		donAmtSheet.loadSearchData(result);  //data 로딩 처리
		// @ts-ignore
		donAmtSheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

		

		// @ts-ignore
		//makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화
	} 

	//기부금품지출명세서 
    async function getSuppMoneySheetData (){
		let param = {
			"YEAR" : year == ''?new Date().getFullYear():year
		};

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'adm_3100_getSuppMoneySheetData',
			data: param
		})

		//전체데이터
		let result = response.LIST;

		 if(result !=null && result.length > 0){
		// 	//전체ROW개수
		// 	totalCnt = Object.keys(result).length;
		 	setSuppMoneySheetRowCnt(Object.keys(result).length);
		 }

		//데이터 처리
		ib.suppMoneyData = result;

		// @ts-ignore
		suppMoneySheet.loadSearchData(result);  //data 로딩 처리
		// @ts-ignore
		suppMoneySheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

	} 

	//출연금 사용명세서 (수혜대상법인명)  
    async function getPayRedeSheetData (){
		let param = {
			"YEAR" : year == ''?new Date().getFullYear():year
		};


		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'adm_3100_getPayRedeSheetData',
			data: param
		})

		//전체데이터
		let result = response.LIST;


		 if(result !=null && result.length > 0){
		// 	//전체ROW개수
		// 	totalCnt = Object.keys(result).length;
		 	setPayRedeSheetRowCnt(Object.keys(result).length);
		 }

		//데이터 처리
		ib.payRedeData = result;

		// @ts-ignore
		payRedeSheet.loadSearchData(result);  //data 로딩 처리
		// @ts-ignore
		payRedeSheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

	} 

	

	//====== 그리드 데이터 가지고 오기  START
	async function doSearch(sAction:string) {
		let param = {
			"YEAR" : year == ''?new Date().getFullYear():year,
			"BIZ_CD" : bizCd,
			"DON_CONT_DIV_CD" : donContDivCd,
			"CORP_NM" : corpNm,
			"BIZ_NO" : bizNo
		};

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'adm_3100_selectList',
			data: param
		})

		//전체데이터
		let result = response.LIST;

		if(result !=null && result.length > 0){
			//전체ROW개수
			totalCnt = Object.keys(result).length;
			setTotalRowCnt(Object.keys(result).length);
		}

		//데이터 처리
		ib.data = result;

		// @ts-ignore
		sheet.loadSearchData(result);  //data 로딩 처리
		// @ts-ignore
		sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		// @ts-ignore
		makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화

	}

	//====== 그리드 데이터 가지고 오기  END

	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}

			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}

			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = totalCnt // 전체 조회 건수
			// @ts-ignore
			let page = defaultRowCnt; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';

			let k = 1;

			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);

				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}

			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}

			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);

				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}

			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			alert(ex.message);
		}
	}

	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number) {
		// @ts-ignore
		sheet.goToPageByIndex(cPage);

	}

	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}

	 //date to String 
	 function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	//만기도래일 체크 
	function dueDateConverter(dueDate, type){
		if(dueDate == null) return '';

		if(type == 'date'){
			dueDate = dateToStr(dueDate);
			return dueDate.substring(0, 10);
		}else if(type == 'diff'){
			if(/^(-?)[0-9]+$/.test(dueDate)){
				dueDate = Number(dueDate);
			}

			const due = new Date(dueDate);
			const now = new Date();
			const timeGap = due.getTime() - now.getTime();

			// 남은 일수 카운트
			const remainDay = Math.ceil(timeGap / (1000 * 60 * 60 * 24));
			return remainDay;
		}

		return '';
	}

	//만기도래일 계산 
	function dueDateFormula(fr) {
		let dueDay = fr.Row.DUE_DATE;
		let d_day = dueDateConverter(dueDay,'diff');
		if(d_day < 0 ){
			let d_days = (d_day * -1);  //음수를 양수로
			d_day =  '<font color="red"> (D+' +d_days +') </font>';  //만기일이 지난경우 빨간색으로 표시
		}else if(d_day == 0){
			d_day =  '<font color="blue"> (D-DAY) </font>';  //D-DAY일경우 파란색 표시
		}else{
			d_day = '(D-' +d_day +')';
		}
		
		dueDay += d_day;

		return dueDay;
	}

	//연장공문 계산 
	function extCheckFormula(fr) {
		//let suppAmt = Number(fr.Row.DON_REQ_AMT) - Number(fr.Row.NOW_QTY);
		let extCheck = fr.Row.EXT_NOTI_VIEW
    
		//지원금액을 다 사용했으면(0원) 연장공문표시 안함 
		//if(suppAmt == 0){
		//	extCheck = '';
		//}
		 
		return extCheck;

	}

	//연장공문 미리 보기  
	async function uploadFileReView(paramFileId:string) {
        //파일정보
        let param = {
			"FILE_ID": paramFileId
		};

		const response:any = await CommonUtil.execute({
			url:'adm_3100_getFileInfo',
			data: param
		})

		const result = response;
        if(response !=null){
			let fileInfoList = result.FILE_INFO_LIST;

			const tempFileValue = new TbComFile();
			 //파일정보 있을경우
			//@ts-ignore
			if(fileInfoList!= null){
				fileInfoList?.forEach((item, index) => {
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(item.DWLD_ID);
					fileDetail.setFileDetailId(item.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(item.FILE_POLICY);
					fileDetail.setFileRpstr(item.FILE_RPSTR);
					fileDetail.setStrePath(item.STRE_PATH);
					fileDetail.setStreFileNm(item.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(item.FILE_EXTSN);
					fileDetail.setFileSize(Number(item.FILE_SIZE));
					fileDetail.setRegistDt(item.REGIST_DT);
					fileDetail.setRegistPsnNm(item.REGIST_PSN_NM);

					tempFileValue.putTbComFileMapngDetailList(fileDetail);
				})
			}
			
			setFileValue(tempFileValue);
		
			setLoadFinish(true);
		}

		if(fileValue != null){
			//setModaladm3100ViewOpen(true);  //수정
			setModaladm3100Open(true);
		}
	}

	//연장공문 업데이트 
	async function uploadFileUpdate() {
        //파일정보
        let param = {
			"FILE_ID": fileId
		};

		const response:any = await CommonUtil.execute({
			url:'adm_3100_getFileInfo',
			data: param
		})

		const result = response;
        if(response !=null){
			let fileInfoList = result.FILE_INFO_LIST;

			 //파일정보 있을경우
			//@ts-ignore
			if(fileInfoList!= null){
				const tempFileValue = new TbComFile();
				fileInfoList?.forEach((item, index) => {
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(item.DWLD_ID);
					fileDetail.setFileDetailId(item.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(item.FILE_POLICY);
					fileDetail.setFileRpstr(item.FILE_RPSTR);
					fileDetail.setStrePath(item.STRE_PATH);
					fileDetail.setStreFileNm(item.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(item.FILE_EXTSN);
					fileDetail.setFileSize(Number(item.FILE_SIZE));
					fileDetail.setRegistDt(item.REGIST_DT);
					fileDetail.setRegistPsnNm(item.REGIST_PSN_NM);

					tempFileValue.putTbComFileMapngDetailList(fileDetail);
				})
				setFileValueUpdate(tempFileValue);
			}
		
			setLoadFinish(true);
		}

		setModaladm3100Open(true);
	}


	//페이지 건수별로 보기
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			defaultRowCnt = e.target.value;
			// @ts-ignore
			IBSheet.disposeAll(true);
			ib.init.Cfg.PageLength = e.target.value;
			ib.create();
		}else if(e.target.name === 'receSts'){
			setReceSts(e.target.value);
		}else if(e.target.name === 'donContDivCd'){
			setDonContDivCd(e.target.value);
		}else if(e.target.name === 'year') {
			setYear(e.target.value);
		}
		
	};

	//인풋 엔터체크
	const activeEnter = (e) => {
        if(e.key === "Enter") {
            doSearch("search");
        }
    }

	/**
   * 사업자등록증 등록/갱신
   */
	//const [uploadId, setUploadId] = React.useState("");
	let uploadId = useRef<string>("");

	//파일업로드 
    const onCreationComplete = function (uploadID: string) {
        uploadId.current = uploadID;
    }

	//연장공문 업로드 
	async function formCheck3100() {

		setFormCheck(true);
		//파일업로드 
		onFileUpload();
	}

	//연장공문 수정 우선 사용안함 
	async function formCheck3100Update() {
       setModaladm3100ViewOpen(false);
	   uploadFileUpdate();   //파일이 정보 가지고 오기 
	}

	//파일업로드
	const onFileUpload = () => {
	
		if( uploadId.current){
			window["RAONKUPLOAD"].Transfer( uploadId.current);
		}
	}

	//파일업로드 완료
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array',  uploadId.current);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
	   
		let fileInfos : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		}[] = [];

		let fileInfo : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		};

		//파일등록 정보
		arrayNew?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"ADD"
			}

			fileInfos.push(fileInfo);
		})

		//파일등록 정보
		arrayDel?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				//STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				STRE_PATH:item.uploadPath,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);
			
		})

		setFileInfoUploadList(fileInfos);

    }

	// 파일 업로드 성공여부 체크
	React.useEffect(() => {
		if(fileInfoUploadList && formCheck) {
			// 파일 업로드 성공
			let param ={
				"DON_NO":donNo
				,"FILE_ID":fileId
				,"FILE_INFO_LIST":fileInfoUploadList
			}

			//연장공문업로드 정보 저장 
			extNotiFileUpload(param);
		   

		}
	}, [fileInfoUploadList])


	//연장공문업로드 정보 저장 
	async function extNotiFileUpload(sendParam:any) {

		if(fileInfoUploadList.length == 0){
			UIUtils.alert("선택한 파일이 없습니다.").then();
			return;
		}

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'adm_3100_extNotiFileId_Update',
			data: sendParam
		}).then((response:any) => {
			setFormCheck(false);
            setModaladm3100Open(false);

			if(receivedData == undefined){
				doSearch('init');
			}else{
				if(JSON.stringify(receivedData.searchData) =='{}'){
					doSearch('init');
				}else{
					doSearch('search');
				}
			}
		}).catch(err => {
			CommonUtil.showAxiosError(err);
			return;
		});	
	}

	async function handleClose(){
		setModaladm3100Open(false);
	}

	async function modaladm3100ViewClose(){
		setModaladm3100ViewOpen(false);
	}

	// 출연받은재산사용명세서 모달 오픈
	async function modalDonAmtOpenPop() {
		// @ts-ignore
		if(IBSheet.donAmtSheet !==undefined){
			// @ts-ignore
			IBSheet.donAmtSheet.dispose();
		}
		
		setModalDonAmtOpen(true)
	}


	//출연받은재산사용명세서 엑셀출력
	async function modalDonAmtClosePop() {
		// @ts-ignore
		if(IBSheet.donAmtSheet !==undefined){
			// @ts-ignore
			IBSheet.donAmtSheet.dispose();
		}
		setModalDonAmtOpen(false);
	}

	//출연받은재산사용명세서 모달 닫기 
	async function onAfterModalDonAmtOpen() {
		// @ts-ignore
		if(IBSheet.donAmtSheet !==undefined){
			// @ts-ignore
			IBSheet.donAmtSheet.dispose();
		}
		ib.createDonAmtSheet();
    }



	// 기부금품지출명세서 모달 오픈
	async function modalSuppMoneyOpenPop() {
		// @ts-ignore
		if(IBSheet.suppMoneySheet !==undefined){
			// @ts-ignore
			IBSheet.suppMoneySheet.dispose();
		}
		
		setModalSuppMoneyOpen(true)
	}


	//기부금품지출명세서 엑셀출력
	async function modalSuppMoneyClosePop() {
		// @ts-ignore
		if(IBSheet.suppMoneySheet !==undefined){
			// @ts-ignore
			IBSheet.suppMoneySheet.dispose();
		}
		setModalSuppMoneyOpen(false);
	}

	//기부금품지출명세서 모달 닫기 
	async function onAfterModalSuppMoneyOpen() {
		// @ts-ignore
		if(IBSheet.suppMoneySheet !==undefined){
			// @ts-ignore
			IBSheet.suppMoneySheet.dispose();
		}
		ib.createSuppMoneySheet();
    }

	// 출연금사용명세 모달 오픈
	async function modalPayRedeOpenPop() {
		// @ts-ignore
		if(IBSheet.payRedeSheet !==undefined){
			// @ts-ignore
			IBSheet.payRedeSheet.dispose();
		}
		
		setModalPayRedeOpen(true)
	}


	//출연금사용명세 엑셀출력
	async function modalPayRedeClosePop() {
		// @ts-ignore
		if(IBSheet.payRedeSheet !==undefined){
			// @ts-ignore
			IBSheet.payRedeSheet.dispose();
		}
		setModalPayRedeOpen(false);
	}

	//출연금사용명세 모달 닫기 
	async function onAfterModalPayRedeOpen() {
		// @ts-ignore
		if(IBSheet.payRedeSheet !==undefined){
			// @ts-ignore
			IBSheet.payRedeSheet.dispose();
		}
		ib.createPayRedeSheet();
    }


	//그리드 내용 저장
	async function doSave (){
		// @ts-ignore
		var rows = sheet.getDataRows();
		
		// 각 컬럼에 수정된 데이터와 DESC 컬럼의 Color 속성값을 추출한다.
		// @ts-ignore
		var saveJson = sheet.getSaveJson({saveMode:2});

		var saveItems: { PRE_QTY: number;NOW_QTY: number;SUPP_AMT: number;DON_NO:string;MEMO:string
			}[] = [];
		
		 //파일등록 정보
		 saveJson.data?.forEach((item, index) => {
            saveItems.push({
				PRE_QTY: item.PRE_QTY, NOW_QTY:item.NOW_QTY, SUPP_AMT:item.SUPP_AMT,DON_NO:item.DON_NO, MEMO:item.MEMO
            });

        })
		
		//console.log("saveItems :" + saveItems.length +" / " + JSON.stringify(saveItems));
		let saveItemsLength:number = saveItems.length;
		if(saveItemsLength > 0){
 
			if (await UIUtils.confirm("변경된 이력이 있습니다. 저장하시겠습니까?")) {
				let params = {
					"SAVE_LIST" : saveItems
				}
				
				const response:any = await CommonUtil.execute({
					url:"adm_3100_save",
					data: params
				}).catch((error: {COMMON_HEAD:any}) => {
					CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
					return false;
				});

				if (response) {
					UIUtils.alert("저장되었습니다.").then(()=>{
						if(receivedData == undefined){
							doSearch('init');
						}else{
							if(JSON.stringify(receivedData.searchData) =='{}'){
								doSearch('init');
							}else{
								doSearch('search');
							}
						}
					});
				}
			}
		}else{
			UIUtils.alert("변경된 내용이 없습니다.").then();
			return;  
		}
    }

	// init
	React.useEffect(() => {

		//필요한 공통코드 로딩.
		codeDataStore.read("cfms.portalBizCdList").then(()=>{
			//ib시트 생성
			ib.create();
		});


		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	},[])

	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">공시/발급</a></li>
						<li className=""><a href="">법인세공시</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">법인세 공시</h1>

						<div className="sf  sf-3col">
							<div className="inner">
							<div className="sf-item">
								<p className="sf-key">출연년도</p>
									<div className="sf-value">
										<div className="sl sl-md w100p">
											<select name="year" id="year" value={year} onChange={(handleSelect)}>
												<option value="">전체</option>
												{yearList.map((year, idx) => (
													<option value={year.value}>{year.nm}</option>
												))}
											</select>
										</div>

									</div>
								</div>
								
								<div className="sf-item">
									<p className="sf-key">사업명</p>
									<div className="sf-value">
									<div className="sl sl-md w100p">
										<UISelect
											value={bizCd}
											valueChanged={(value) => setBizCd(String(value))}
											codeData={codeDataStore.get("cfms.portalBizCdList")}
											firstName={"all"}
										/>
										</div>
									</div>
								</div>
								<div className="sf-item">
									<p className="sf-key">기부내용</p>
									<div className="sf-value">
										<div className="sl sl-md w100p">
											{/* <UISelect
												value={donContDivCd}
												valueChanged={(value) => setDonContDivCd(value)}
												codeData={codeDataStore.get("[DCDC]")}
												firstName={"all"}
											/> */}
											<select name="donContDivCd" id="donContDivCd" value={donContDivCd} onChange={handleSelect}>
												<option value=''>전체</option>
												<option value='M'>현금</option>
												<option value='C'>물품</option>
											</select>
										</div>
									</div>
								</div>
								<div className="sf-item">
									<p className="sf-key">사업자번호</p>
									<div className="sf-value">
										<UIInput className={'tf tf-md w100p'} value={bizNo}	valueChanged={(value) => setBizNo(value)} placeholder={'-없이 숫자만'} onKeyEnter={(e) => activeEnter(e)}/>
									</div>
								</div>
								<div className="sf-item">
									<p className="sf-key">출연기업</p>
									<div className="sf-value">
										<UIInput className={'tf tf-md w100p'} value={corpNm} valueChanged={(value) => setCorpNm(value)} onKeyEnter={(e) => activeEnter(e)}/>
									</div>
								</div>
							</div>
						</div>
						<div className="hz-root hz-center mb30">
							<button className="bt" data-color="pri" data-size="md"  type="button" onClick={()=>{doSearch('search')}}>조회</button>
						</div>

						<div className="tb-top">
							<div>
								<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
							</div>
							<div className="hz-root hz-gap5">
								<Button color="pri-o" size="sm" onClick={modalDonAmtOpenPop}>출연받은재산사용명세서</Button>
								{/* <Button color="pri-o" size="sm" onClick={modalSuppMoneyOpenPop}>기부금품지출명세서</Button> */}
								<Button color="pri-o" size="sm" onClick={modalPayRedeOpenPop}>출연금사용명세</Button>
								<Button color="gray-o" size="sm" onClick={()=> ib.exportData()}>다운로드</Button>
								<Button color="gray-o" size="sm" onClick={() => doSave()}>저장</Button>
								<div className="sl sl-sm w120">
									<select name="showRowCnt" id="showRowCnt" onChange={(handleSelect)}>
										<option value="20">20개씩보기</option>
										<option value="50">50개씩보기</option>
										<option value="100">100개씩보기</option>
										<option value="200">200개씩보기</option>
										<option value="500">500개씩보기</option>
										<option value="1000">1000개씩보기</option>
									</select>
								</div>
							</div>
						</div>
						<div id='sheetDiv'>[D] IBSHEET 영역</div>
						<div id="pageNavi" className="pg"></div>
					</main>

				</div>
			<ModalPopup
				open={modaladm3100Open}
				title={titleText.current}
				size="mid"
				onClose={handleClose}
				onAfterClose={()=>{commonPopupStore.closeLastPopup()}}
			    >
				<div className="modal-con">
					<UI.FileUpload
						value={fileValue}
						onCreationComplete={onCreationComplete}
						onUploadComplete={onUploadComplete}
						attrs={{
							MaxTotalFileCount: "1",
							ExtensionAllowOrLimit: "1",
							//ExtensionArr: "pdf"
						}}
					/>
				</div>
				<div className="modal-bottom">
					<Button color='pri' size="md" onClick={formCheck3100}>저장</Button>
				</div>
			</ModalPopup>	

           {/*  사용안함  */}
			<ModalPopup
				open={modaladm3100ViewOpen}
				title={titleText.current}
				size="mid"
				onClose={modaladm3100ViewClose}
				onAfterClose={()=>{commonPopupStore.closeLastPopup()}}
			    >
				<div className="modal-con">
					<UI.FileDownload
						value={fileValue}
						className={"w100p"}
						onError={(uploadID, paramObj) => {
							console.log(uploadID, paramObj);
						}}
						attrs={{ImgPreView: "1",Views: "thumbs"}}
						/>
				</div>

				<div className="modal-bottom">
					<Button color='pri' size="md" onClick={modaladm3100ViewClose}>닫기</Button>
					<Button color='pri' size="md" onClick={formCheck3100Update}>수정</Button>
				</div>
			</ModalPopup>	


			{/* modal - 출연받은 재산사용명세서 */}
			<ModalPopup
				open={modalDonAmtOpen}
				title="출연받은 재산의 사용명세서"
				size="xlg"
				onClose={() => modalDonAmtClosePop()}
				onAfterOpen={() => onAfterModalDonAmtOpen()}
			   >
				<div className="modal-con">
					<div className="tb-top">
						<div>
							<p className="tx fc-black">총 <em className="fw500">{donAmtSheetRowCnt}</em>건</p>
						</div>
						<div className="hz-root hz-right hz-gap10 mt30">
							<Button color="gray-o" size="md" onClick={()=>ib.exportDonAmtSheetData()}>다운로드</Button>
						</div>
					
					</div>
					
					<div className="ibsheet" id='sheetDiv1'>
					</div>
					<div id="pageNaviRede" className="pg"></div>
				</div> 
			</ModalPopup>


			{/* modal - 기부금품지출명세서 */}
			<ModalPopup
				open={modalSuppMoneyOpen}
				title="기부금품지출명세서"
				size="xlg"
				onClose={() => modalSuppMoneyClosePop()}
				onAfterOpen={() => onAfterModalSuppMoneyOpen()}
			   >
				<div className="modal-con">
					<div className="tb-top">
						<div>
							<p className="tx fc-black">총 <em className="fw500">{suppMoneySheetRowCnt}</em>건</p>
						</div>
						<div className="hz-root hz-right hz-gap10 mt30">
							<Button color="gray-o" size="md" onClick={()=>ib.exportSuppMoneySheetData()}>다운로드</Button>
						</div>
					
					</div>
					
					<div className="ibsheet" id='sheetDiv2'></div>
				</div> 
			</ModalPopup>

			{/* modal - 출연금 사용명세 */}
			<ModalPopup
				open={modalPayRedeOpen}
				title="출연금 사용명세"
				size="xlg"
				onClose={() => modalPayRedeClosePop()}
				onAfterOpen={() => onAfterModalPayRedeOpen()}
			   >
				<div className="modal-con">
					<div className="tb-top">
						<div>
							<p className="tx fc-black">총 <em className="fw500">{payRedeSheetRowCnt}</em>건</p>
						</div>
						<div className="hz-root hz-right hz-gap10 mt30">
							<Button color="gray-o" size="md" onClick={()=>ib.exportPayRedeSheetData()}>다운로드</Button>
						</div>
					
					</div>
					
					<div className="ibsheet" id='sheetDiv3'></div>
				</div> 
			</ModalPopup>

		</PageContainer>
	);
}
export default ContentsContainer;


